import React, {useEffect} from 'react';
import {DragDrop, BrowserRouter, Layout, Popup} from 'components';
import {Provider} from 'react-redux';
import {config, useEvent, useHistory, loadScript, useLocation, getQueryClient} from 'helpers';
import {store} from 'store/store';
import {QueryClientProvider} from '@tanstack/react-query';

export function App({hot}: {hot?: boolean}) {
  useEffect(() => {
    store.dispatch({
      type: hot ? 'APP_HOT_LAUNCH' : 'APP_LAUNCH',
      online: window.navigator.onLine,
      location: window.location
    });
  }, []);
  useEvent('online', () => store.dispatch({type: 'SESSION_ONLINE'}));
  useEvent('offline', () => store.dispatch({type: 'SESSION_OFFLINE'}));
  return (
    <QueryClientProvider client={getQueryClient()}>
      <Provider store={store}>
        <BrowserRouter>
          <Popup.Manager />
          <DragDrop.Boundaries target={{current: window}} />
          <Layout.Manager />
          <RedirectListener />
          {!config.development && <PageTracker />}
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  );
}

const RedirectListener = () => {
  const history = useHistory();
  useEvent('redirect', ({detail}) => {
    if (detail.replace) {
      history.replace(detail.url);
    } else {
      history.push(detail.url);
    }
  });
  return null;
};

const PageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    loadScript(`https://www.googletagmanager.com/gtm.js?id=${config.googleTag}`);
  }, []);
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageview',
      pagePath: location.pathname,
      pageTitle: document.title,
    });
  }, [location]);
  return null;
};
